import reducer from '../utils/stateManagement/reducer.js';
import Api from '../utils/api/api.js';
import useDynTabs from './useDynamicTabs.js';
import { ApiContext, StateContext, ForceUpdateContext } from '../context.js';
import Components from '../components/index.js';
var getDeps = function getDeps() {
  var getApiInstance = function getApiInstance(options, modules, Components) {
    return new Api({
      options: options
    }, modules, Components);
  };
  return {
    reducer: reducer,
    getApiInstance: getApiInstance,
    ApiContext: ApiContext,
    StateContext: StateContext,
    ForceUpdateContext: ForceUpdateContext,
    Components: Components
  };
};
export default useDynTabs.bind(null, getDeps);